import { fetchTokenAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const vmwareVSphere = defineConnector({
  identifier: "vmwareVSphere",
  name: "VMware vSphere",
  tagLine: "Virtualization and infrastructure APIs",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ url }) =>
    url ? `${url}/.*` : "https://vsphere\\.example\\.com/.*",
  auth: (app) =>
    fetchTokenAuth({
      request: {
        url: `${app.config.url}/api/session`,
        method: "POST",
        basicAuth: {
          username: app.secret.username,
          password: app.secret.password,
        },
      },
      extract: { from: "jsonPath", paths: ["value"] },
      apply: { kind: "header", name: "vmware-api-session-id" },
    }),
  steps: [
    {
      title: "Create an account or API user",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://developer.broadcom.com/xapis/vsphere-automation-api/latest/cis/cis-session/](https://developer.broadcom.com/xapis/vsphere-automation-api/latest/cis/cis-session/) to create a vSphere account that can open API sessions. Broadcom's current REST docs create a session with `POST /api/session`, then require the returned value in the `vmware-api-session-id` header on later requests.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "baseUrl",
          label: "VMware vSphere base URL",
          placeholder: "https://vsphere.example.com",
          required: true,
          target: {
            kind: "configuration",
            field: "url",
          },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: {
            kind: "secrets",
            field: "username",
          },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: {
            kind: "secrets",
            field: "password",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://vsphere.example.com/health",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod, ...configuration }) => ({
      url:
        testUrl ?? (({ url }) => `${url}/api/vcenter/cluster`)(configuration),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
